(() => {
  const roots = document.querySelectorAll('[data-shop-controls]');

  roots.forEach((root) => {
    const disclosures = Array.from(root.querySelectorAll('details'));
    const disclosureStateKey = 'mondo-shop-filter-disclosure';

    try {
      const savedState = JSON.parse(window.sessionStorage.getItem(disclosureStateKey));
      const savedDisclosure = disclosures.find(
        (disclosure) => disclosure.dataset.shopDisclosure === savedState?.name,
      );

      if (savedDisclosure) {
        savedDisclosure.open = true;
        const savedMenu = savedDisclosure.querySelector('.shop-filter__menu');
        if (savedMenu) savedMenu.scrollTop = savedState.scrollTop || 0;
      }

      window.sessionStorage.removeItem(disclosureStateKey);
    } catch {}

    root.addEventListener('change', (event) => {
      const filterInput = event.target.closest('[data-shop-filter-input]');
      if (!filterInput) return;

      const filterUrl = filterInput.dataset.filterUrl;
      if (!filterUrl) return;

      const disclosure = filterInput.closest('[data-shop-disclosure]');
      const menu = filterInput.closest('.shop-filter__menu');

      try {
        window.sessionStorage.setItem(
          disclosureStateKey,
          JSON.stringify({
            name: disclosure?.dataset.shopDisclosure,
            scrollTop: menu?.scrollTop || 0,
          }),
        );
      } catch {}

      filterInput.disabled = true;
      window.location.assign(filterUrl);
    });

    disclosures.forEach((disclosure) => {
      disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) return;

        disclosures.forEach((candidate) => {
          if (candidate !== disclosure) candidate.open = false;
        });
      });
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      const openDisclosure = disclosures.find((disclosure) => disclosure.open);
      if (!openDisclosure) return;

      openDisclosure.open = false;
      openDisclosure.querySelector('summary')?.focus();
    });

    document.addEventListener('click', (event) => {
      if (root.contains(event.target)) return;
      disclosures.forEach((disclosure) => {
        disclosure.open = false;
      });
    });
  });
})();
